var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGaleriaSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.979,
    height: 20.968,
    viewBox: "0 0 23.979 20.968",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Galeria-Accesorios",
    transform: "translate(-1.2 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GeneralSystems_Image_48",
    "data-name": "GeneralSystems/Image/48",
    transform: "translate(1.2 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "O171---Image",
    className: "cls-1",
    d: "M23.6,4a1.559,1.559,0,0,1,1.578,1.654h0V23.315a1.668,1.668,0,0,1-1.654,1.653H2.854A1.668,1.668,0,0,1,1.2,23.315h0V5.654A1.686,1.686,0,0,1,2.929,4H23.6ZM8.791,11.816,2.778,18.881v4.434a.161.161,0,0,0,.15.15H23.6c.076,0,.151-.075.226-.075h0v-2.18l-4.584-5.036-3.232,2.63a1.307,1.307,0,0,1-1.127.376,1.645,1.645,0,0,1-1.052-.6h0ZM23.6,5.5H2.929c-.15,0-.226.076-.226.151h0v10.9l4.961-5.862a1.351,1.351,0,0,1,1.127-.526,1.519,1.519,0,0,1,1.052.6h0l5.186,6.914,3.081-2.706a1.614,1.614,0,0,1,2.18.15h0l3.457,3.758V5.654A.162.162,0,0,0,23.6,5.5Zm-5.862,7.516a3,3,0,0,1-3.006-2.931,3.007,3.007,0,0,1,6.013,0A3,3,0,0,1,17.734,13.018Zm0-4.359a1.494,1.494,0,0,0-1.5,1.428,1.505,1.505,0,0,0,3.006,0A1.494,1.494,0,0,0,17.734,8.66Z",
    transform: "translate(-1.2 -4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaleriaSelected);
export default __webpack_public_path__ + "static/media/galeria-selected.aad6d1ddeac07661bea50fbd5a6389e3.svg";
export { ForwardRef as ReactComponent };